var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalDetailsselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50092 9.80769C11.2014 9.80769 13.3905 7.61217 13.3905 4.90385C13.3905 2.19553 11.2014 0 8.50092 0C5.80047 0 3.61133 2.19553 3.61133 4.90385C3.61133 7.61217 5.80047 9.80769 8.50092 9.80769Z",
    fill: "#2F94A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.35638 16.3298C1.16439 12.907 4.5541 11.0337 8.0636 11.0337H8.9364C12.4459 11.0337 15.8356 12.9057 16.6436 16.3298C16.8001 16.9931 16.9248 17.687 16.9944 18.3919C17.0617 19.0662 16.5092 19.6154 15.8344 19.6154H1.16561C0.490844 19.6154 -0.0616798 19.065 0.00555216 18.3919C0.0752289 17.687 0.199913 16.9931 0.35638 16.3298Z",
    fill: "#2F94A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailsselected);
export default __webpack_public_path__ + "static/media/Personal Details selected.0e71f82c3eaa27da2cf299a0ed48baf4.svg";
export { ForwardRef as ReactComponent };